import type { MobileStorePlatform } from './device';

/** Fixed App Store / Google Play URLs for Zippy Pay (managed server-side; not merchant-configurable). */
export type AppStoreLinks = {
  ios: string;
  android: string;
};

export const ANDROID_APP_PACKAGE = 'com.zippy.pay';
export const IOS_APP_STORE_URL =
  'https://apps.apple.com/in/app/zippypay/id6806799311';

/** HTTPS store URLs — used for QR codes and desktop fallback links. */
export const APP_STORE_LINKS: AppStoreLinks = {
  ios: IOS_APP_STORE_URL,
  android: `https://play.google.com/store/apps/details?id=${ANDROID_APP_PACKAGE}`,
};

/** Opens the native App Store app on iOS to the Zippy Pay listing. */
export const IOS_APP_STORE_NATIVE_URL = `itms-apps://${IOS_APP_STORE_URL.replace(/^https:\/\//, '')}`;

/** Opens the native Play Store app on Android. */
export const ANDROID_PLAY_STORE_NATIVE_URL = `market://details?id=${ANDROID_APP_PACKAGE}`;

export function resolveAppStoreUrl(platform: MobileStorePlatform): string {
  return APP_STORE_LINKS[platform];
}

/**
 * URL used when the customer taps Install Zippy.
 * iOS and Android both use native store schemes from a user gesture.
 */
export function resolveAppStoreOpenUrl(platform: MobileStorePlatform): string {
  if (platform === 'ios') {
    return IOS_APP_STORE_NATIVE_URL;
  }
  return ANDROID_PLAY_STORE_NATIVE_URL;
}
